<category-component></category-component>
<div class="side-space-wrapper grey-color fixed-header-height place-order-wrapper">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 banner-image">
                <img *ngIf="bannerDetails.bannerOrderCompleteImageWebsite != ''"
                    src="{{bannerDetails.bannerOrderCompleteImageWebsite}}" alt="">

            </div>
            <div class="col-12">
                <div class="order-confirmation-box  white-background">
                    <img src="../../assets/images/success.svg" alt="success">
                    <h2 *ngIf="orderDetail.card_payment != 1">Order Placed Successfully</h2>
                    <h2 *ngIf="orderDetail.card_payment == 1">Payment made Successfully</h2>
                    <p *ngIf="orderDetail.card_payment == 1">Your order has been placed.</p>
                    <p class="order-id" *ngIf="orderDetail">Order Id: {{orderDetail.order_id}} </p>
                    <p class="order-id" *ngIf="orderDetail && orderDetail.card_payment == 1">Transaction Id:
                        {{orderDetail.transaction_payment_id }} </p>
                    <p class="order-id" *ngIf="orderDetail && orderDetail.card_payment == 1">Transaction Date:
                        {{orderDetail.transaction_date }} </p>
                    <p>Thanks for placing your order with World Of Sweets</p>

                    <p class="skip-survey" *ngIf="isRetailerOnly && surveyUrl !== '' && isStoreSkiped">Skipped the Survey? <a class="primary" href="javascript:void(0);" routerLink="/feedback">Click here</a> to participate.</p>
                </div>
            </div>
            <div class="col-12">
                <div class="confirmation-detail-box white-background">
                    <p class="bold">Order Summary</p>
                    <ul class="order-list">
                        <li>
                            <label *ngIf="orderDetail.items_count == '1'">Item</label>
                            <label *ngIf="orderDetail.items_count != '1'">Items</label>
                            <p>{{orderDetail.items_count}}</p>
                        </li>
                        <li>
                            <label *ngIf="orderDetail.items_qty == '1'">Case</label>
                            <label *ngIf="orderDetail.items_qty != '1'">Cases</label>
                            <p>{{orderDetail.items_qty}}</p>
                        </li>
                        <li>
                            <label>Order Date</label>
                            <p>{{orderDetail.order_date}}</p>
                        </li>
                        <li *ngIf="orderDetail.price_visibility == 1">
                            <label>Cost</label>
                            <p>£{{orderDetail.grand_total}}</p>
                        </li>
                    </ul>
                    <p class="bold"
                        *ngIf="orderDetail.is_discount == '1' && orderDetail.free_products.length > 0 && orderDetail.card_payment != 1">
                        Free Products</p>
                    <div
                        *ngIf="orderDetail.is_discount == '1' && orderDetail.free_products.length > 0 && orderDetail.card_payment != 1">
                        <div *ngFor="let product of orderDetail.free_products" class="free-order-list">
                            <p class="detail">{{product.product_name}} <br></p>
                            <p>{{product.product_qty}}</p>
                        </div>
                    </div>
                    <div class="offer-box"
                        *ngIf="orderDetail.items_count != '0' && orderDetail.is_discount == '1' && orderDetail.price_visibility != 1">
                        <p>Invoice cost price and discounts will be applied as per your terms.</p>
                    </div>
                </div>
                <div class="btn-container" (click)="openModal(template)" *ngIf="isRetailerOnly && surveyUrl !== ''">
                    <a class="btn primary-btn" title="Continue Shopping">Return to Home</a>
                </div>
                <div class="btn-container " (click)="redirectToHome(false)" *ngIf="!isRetailerOnly || (isRetailerOnly && surveyUrl == '')">
                    <a class="btn primary-btn" title="Continue Shopping">Return to Home</a>
                </div>

            </div>
        </div>
    </div>
</div>


<ng-template #template>
    <div class="modal-header feedback-modal">
        <h4 class="modal-title pull-left">We value your feedback</h4>
        <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide()">
            <img src="../../../../assets/images/close-feedbnack.svg" alt="">
        </button>
    </div>
    <div class="modal-body p-0">
        <div class="feedback-modal-body">
            {{popuptext}}
        </div>
    </div>
    <div class="footer-buttons">
        <button class="remind-me" (click)="skipSurvey()">Skip Survey</button>    
        <button class="rate" (click)="redirectToFeedback()">Take Survey</button>
        <button class="skip w-100" (click)="redirectToHome()">Remind Me Later</button>
    </div>
</ng-template>